module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_0.16ec1e6e.png";